/**
 * Firebase Analytics Event Names & Types
 *
 * All custom events tracked across the Murphy Zoom platform
 */

// ==================== PHASE 1: CRITICAL EVENTS ====================

// === PAYMENT & CONVERSION FUNNEL ===
export const AnalyticsEvents = {
  // Join/Registration Flow
  VIEW_JOIN_PAGE: 'view_join_page',
  VIEW_PLAN_OPTIONS: 'view_plan_options',
  SELECT_PRICING_PLAN: 'select_pricing_plan',
  CHANGE_PRICING_PLAN: 'change_pricing_plan',
  START_REGISTRATION_FORM: 'start_registration_form',
  REGISTRATION_FORM_FIELD_COMPLETE: 'registration_form_field_complete',
  REGISTRATION_FORM_VALIDATION_ERROR: 'registration_form_validation_error',
  APPLY_INVITE_CODE: 'apply_invite_code',
  APPLY_INVITE_CODE_FAILED: 'apply_invite_code_failed',
  SUBMIT_REGISTRATION_FORM: 'submit_registration_form',
  /** Form validated and user sent to payment; actual registration happens only after payment success. */
  REGISTRATION_FORM_VALIDATED: 'registration_form_validated',
  REGISTRATION_FORM_ERROR: 'registration_form_error',

  // Payment Flow
  VIEW_PAYMENT_PAGE: 'view_payment_page',
  SELECT_PAYMENT_METHOD: 'select_payment_method',
  INITIATE_PAYMENT: 'initiate_payment',
  PAYMENT_REDIRECT: 'payment_redirect',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILURE: 'payment_failure',
  VIEW_PAYMENT_SUCCESS_PAGE: 'view_payment_success_page',
  VIEW_PAYMENT_FAILURE_PAGE: 'view_payment_failure_page',
  PAYMENT_RETRY_ATTEMPTED: 'payment_retry_attempted',
  PAYMENT_ABANDONED: 'payment_abandoned',

  // Class Booking & Scheduling
  VIEW_SCHEDULE_PAGE: 'view_schedule_page',
  VIEW_CLASS_LIST: 'view_class_list',
  VIEW_CLASS_DETAILS: 'view_class_details',
  CLICK_CLASS_CARD: 'click_class_card',
  ATTEMPT_BOOK_CLASS: 'attempt_book_class',
  BOOK_CLASS_SUCCESS: 'book_class_success',
  BOOK_CLASS_FAILURE: 'book_class_failure',
  VIEW_MY_CLASSES_PAGE: 'view_my_classes_page',
  TOGGLE_FAVORITE_CLASS: 'toggle_favorite_class',
  ATTEMPT_CANCEL_BOOKING: 'attempt_cancel_booking',
  CONFIRM_LATE_CANCELLATION: 'confirm_late_cancellation',
  CANCEL_BOOKING_SUCCESS: 'cancel_booking_success',
  CANCEL_BOOKING_ABANDONED: 'cancel_booking_abandoned',

  // User Authentication
  VIEW_SIGNIN_PAGE: 'view_signin_page',
  ATTEMPT_SIGNIN: 'attempt_signin',
  SIGNIN_SUCCESS: 'signin_success',
  SIGNIN_FAILURE: 'signin_failure',
  VIEW_FORGOT_PASSWORD_PAGE: 'view_forgot_password_page',
  REQUEST_PASSWORD_RESET: 'request_password_reset',
  PASSWORD_RESET_EMAIL_SENT: 'password_reset_email_sent',
  VIEW_RESET_PASSWORD_PAGE: 'view_reset_password_page',
  COMPLETE_PASSWORD_RESET: 'complete_password_reset',
  PASSWORD_RESET_SUCCESS: 'password_reset_success',
  PASSWORD_RESET_FAILURE: 'password_reset_failure',

  // Page Views (Enhanced)
  PAGE_VIEW: 'page_view',

  // ==================== PHASE 2: HIGH PRIORITY ====================

  // Marketing & Landing Page
  VIEW_HERO_SECTION: 'view_hero_section',
  VIEW_UPCOMING_SESSIONS: 'view_upcoming_sessions',
  CLICK_UPCOMING_SESSION: 'click_upcoming_session',
  VIEW_PRICING_SECTION: 'view_pricing_section',
  VIEW_START_PAGE: 'view_start_page',
  VIEW_GALLERY_SECTION: 'view_gallery_section',
  VIEW_ABOUT_SECTION: 'view_about_section',
  VIEW_ABOUT_PAGE: 'view_about_page',
  VIEW_CLASSES_PAGE: 'view_classes_page',
  VIEW_VOD_PAGE: 'view_vod_page',
  VIEW_INSTAGRAM_FEED: 'view_instagram_feed',
  CLICK_INSTAGRAM_LINK: 'click_instagram_link',
  CLICK_SIGNIN_BUTTON: 'click_signin_button',
  CLICK_JOIN_BUTTON: 'click_join_button',
  CLICK_LOGO: 'click_logo',

  // Waitlist
  VIEW_WAITLIST_PAGE: 'view_waitlist_page',
  START_WAITLIST_FORM: 'start_waitlist_form',
  SUBMIT_WAITLIST_FORM: 'submit_waitlist_form',
  WAITLIST_SUBMISSION_SUCCESS: 'waitlist_submission_success',
  WAITLIST_SUBMISSION_ERROR: 'waitlist_submission_error',

  // Error Tracking
  APP_ERROR: 'app_error',
  API_ERROR: 'api_error',
  PAYMENT_API_ERROR: 'payment_api_error',
  PAYMENT_CALLBACK_FAILED: 'payment_callback_failed',
  FIRESTORE_ERROR: 'firestore_error',
  FIREBASE_AUTH_ERROR: 'firebase_auth_error',

  // Profile Management
  VIEW_PROFILE_PAGE: 'view_profile_page',
  EDIT_PROFILE_FIELD: 'edit_profile_field',
  UPDATE_PROFILE_SUCCESS: 'update_profile_success',
  UPDATE_PROFILE_ERROR: 'update_profile_error',
  UPLOAD_PROFILE_IMAGE: 'upload_profile_image',
  PROFILE_IMAGE_UPLOAD_SUCCESS: 'profile_image_upload_success',
  PROFILE_IMAGE_UPLOAD_FAILURE: 'profile_image_upload_failure',
  VIEW_PURCHASE_MORE_SESSIONS: 'view_purchase_more_sessions',
  CLICK_PURCHASE_PLAN: 'click_purchase_plan',

  // Upgrade Page (in-app conversion surface)
  VIEW_UPGRADE_PAGE: 'view_upgrade_page',
  CLICK_UPGRADE_CTA: 'click_upgrade_cta',

  // Existing User Package Purchase Flow
  VIEW_PURCHASE_PAGE: 'view_purchase_page',
  SELECT_PACKAGE_FOR_PURCHASE: 'select_package_for_purchase',
  INITIATE_EXISTING_USER_PAYMENT: 'initiate_existing_user_payment',
  EXISTING_USER_PAYMENT_REDIRECT: 'existing_user_payment_redirect',
  EXISTING_USER_PAYMENT_SUCCESS: 'existing_user_payment_success',
  EXISTING_USER_PAYMENT_FAILURE: 'existing_user_payment_failure',
  VIEW_PURCHASE_SUCCESS_SPLASH: 'view_purchase_success_splash',
  EXISTING_USER_PAYMENT_ABANDONED: 'existing_user_payment_abandoned',

  // ==================== PHASE 3: NICE TO HAVE ====================

  // Admin/CRM
  VIEW_CRM_DASHBOARD: 'view_crm_dashboard',
  VIEW_CRM_SECTION: 'view_crm_section',
  CREATE_CLASS_FORM_OPEN: 'create_class_form_open',
  CREATE_RECURRING_CLASSES: 'create_recurring_classes',
  CREATE_SINGLE_CLASS: 'create_single_class',
  CLASS_CREATED_SUCCESS: 'class_created_success',
  CLASS_CREATED_ERROR: 'class_created_error',
  EDIT_CLASS: 'edit_class',
  DELETE_CLASS: 'delete_class',
  VIEW_INVITATIONS_PAGE: 'view_invitations_page',
  CREATE_INVITATION: 'create_invitation',
  INVITATION_CREATED_SUCCESS: 'invitation_created_success',
  COPY_INVITATION_LINK: 'copy_invitation_link',
  DELETE_INVITATION: 'delete_invitation',
  VIEW_WAITLIST_PAGE_CRM: 'view_waitlist_page_crm',
  CONTACT_WAITLIST_USER: 'contact_waitlist_user',
  DELETE_WAITLIST_ENTRY: 'delete_waitlist_entry',
  VIEW_IMAGE_SETTINGS: 'view_image_settings',
  UPLOAD_CLASS_TYPE_IMAGE: 'upload_class_type_image',
  UPDATE_INSTRUCTOR_IMAGE: 'update_instructor_image',

  // Zoom Participation
  CLICK_ZOOM_LINK: 'click_zoom_link',
  ZOOM_LINK_UNAVAILABLE: 'zoom_link_unavailable',
  CLASS_REMINDER_SENT: 'class_reminder_sent',
  CLASS_REMINDER_FAILED: 'class_reminder_failed',
  MARK_CLASS_ATTENDANCE: 'mark_class_attendance',

  // Promo Campaigns (e.g. VOD launch)
  VIEW_PROMO_PAGE: 'view_promo_page',
  CLICK_PROMO_CTA: 'click_promo_cta',
  PROMO_INVITE_INVALID: 'promo_invite_invalid',

  // Exit-intent + membership coupons
  EXIT_INTENT_SHOWN: 'exit_intent_shown',
  EXIT_INTENT_DISMISSED: 'exit_intent_dismissed',
  EXIT_INTENT_QUESTION_ANSWERED: 'exit_intent_question_answered',
  EXIT_INTENT_EMAIL_SUBMITTED: 'exit_intent_email_submitted',
  EXIT_INTENT_EMAIL_OPENED: 'exit_intent_email_opened',
  EXIT_INTENT_COUPON_APPLIED: 'exit_intent_coupon_applied',
  EXIT_INTENT_COUPON_REDEEMED: 'exit_intent_coupon_redeemed',

  // Engagement & Retention
  SESSION_START: 'session_start',
  RETURNING_USER_LOGIN: 'returning_user_login',
  FEATURE_DISCOVERED: 'feature_discovered',
  FEATURE_USED_FIRST_TIME: 'feature_used_first_time',
  USER_BOOKING_PATTERN: 'user_booking_pattern',
} as const;

// Type for event names
export type AnalyticsEventName = typeof AnalyticsEvents[keyof typeof AnalyticsEvents];

// ==================== EVENT PARAMETER TYPES ====================

// Payment & Conversion
export interface JoinPageParams {
  has_invite_code?: boolean;
  invite_id?: string;
  referral_source?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export interface PricingPlanParams {
  plan_id: string;
  plan_name: string;
  plan_price: number;
  plan_sessions: number;
  from_plan?: string;
  to_plan?: string;
  invite_id?: string;
}

export interface RegistrationFormParams {
  selected_plan?: string;
  field_name?: string;
  error_type?: string;
  error_message?: string;
  plan_selected?: string;
  discount_applied?: number;
  final_price?: number;
  has_invite?: boolean;
  invite_id?: string;
  transaction_id?: string;
}

export interface InviteCodeParams {
  code_valid: boolean;
  discount_percentage?: number;
  invite_id?: string;
  error_message?: string;
}

export interface PaymentParams {
  transaction_id: string;
  amount: number;
  currency: string;
  payment_provider?: string;
  payment_method?: string;
  test_mode?: boolean;
  plan_purchased?: string;
  sessions_purchased?: number;
  error_reason?: string;
  error_type?: string;
}

export interface PaymentAbandonedParams {
  stage: 'form_incomplete' | 'payment_page_exit' | 'payment_provider_exit';
  transaction_id?: string;
  time_on_page?: number;
}

// Class Booking
export interface SchedulePageParams {
  user_sessions_remaining?: number;
  membership_type?: string;
  total_classes_shown?: number;
  filter_applied?: string;
}

export interface ClassDetailsParams {
  class_id: string;
  class_name: string;
  class_type?: string;
  class_start_time?: string;
  spots_available?: number;
  user_can_book?: boolean;
  time_until_class?: number; // hours
}

export interface BookClassParams {
  class_id: string;
  class_name: string;
  class_type?: string;
  class_start_time?: string;
  booking_lead_time?: number; // hours in advance
  user_sessions_remaining?: number;
  error_reason?: string;
}

export interface CancelBookingParams {
  class_id: string;
  class_name: string;
  hours_until_class?: number;
  will_refund_session?: boolean;
  session_refunded?: boolean;
  cancellation_lead_time?: number;
  cancellation_reason?: string;
}

export interface MyClassesParams {
  total_upcoming_bookings?: number;
  total_past_classes?: number;
  class_id?: string;
  favorited?: boolean;
}

// Authentication
export interface SignInParams {
  method: 'email_password' | 'google_oauth' | 'facebook_oauth';
  redirect_from?: string;
  user_type?: 'admin' | 'trainee';
  time_since_registration?: number; // days
  error_type?: string;
}

export interface PasswordResetParams {
  email_domain?: string;
  reset_code_valid?: boolean;
  error_reason?: string;
}

// Page View
export interface PageViewParams {
  page_title: string;
  page_path: string;
  user_type?: 'admin' | 'trainee' | 'anonymous';
  referrer_source?: string;
}

// Marketing & Landing
export interface MarketingInteractionParams {
  source?: string;
  plan_preselected?: string;
  pricing_plan_viewed?: string;
  instagram_post_id?: string;
}

// Waitlist
export interface WaitlistParams {
  email_domain?: string;
  referral_source?: string;
  error_type?: string;
}

// Error Tracking
export interface ErrorParams {
  error_type: string;
  error_message: string;
  page_url?: string;
  user_action?: string;
  endpoint?: string;
  status_code?: number;
  error_code?: string;
  operation_type?: string;
  collection_name?: string;
  auth_method?: string;
  provider?: string;
}

// Profile
export interface ProfileParams {
  membership_status?: string;
  sessions_remaining?: number;
  days_since_join?: number;
  field_name?: string;
  fields_updated?: string[];
  error_type?: string;
  error_reason?: string;
  current_sessions_remaining?: number;
  plan_selected?: string;
  current_member_status?: string;
}

// Existing User Package Purchase
export interface ExistingUserPurchaseParams {
  user_id?: string;
  transaction_id?: string;
  plan_id?: string;
  plan_name?: string;
  plan_price?: number;
  plan_sessions?: number;
  current_active_packages?: number;
  current_sessions_remaining?: number;
  payment_provider?: string;
  error_reason?: string;
  error_type?: string;
  time_on_page?: number;
  stage?: string;
}

// CRM/Admin
export interface CRMParams {
  active_users_count?: number;
  upcoming_classes_count?: number;
  revenue_this_month?: number;
  section_name?: string;
  class_id?: string;
  class_type?: string;
  occurrences?: number;
  start_date?: string;
  capacity?: number;
  has_zoom_link?: boolean;
  is_recurring?: boolean;
  fields_modified?: string[];
  had_signups?: boolean;
  error_reason?: string;
  invite_id?: string;
  discount_amount?: number;
  invite_code?: string;
  discount_percentage?: number;
  was_used?: boolean;
  total_active_invites?: number;
  total_used_invites?: number;
  total_waitlist_entries?: number;
  uncontacted_count?: number;
  waitlist_id?: string;
  contact_method?: string;
  image_category?: string;
  image_type?: string;
}

// Zoom
export interface ZoomParams {
  class_id: string;
  class_name?: string;
  minutes_before_class?: number;
  reason?: string;
  notification_type?: 'email' | 'sms' | 'whatsapp';
  hours_before_class?: number;
  user_id?: string;
  failure_reason?: string;
  attended?: boolean;
  marked_by?: string;
}

// Engagement
export interface EngagementParams {
  days_since_last_login?: number;
  total_sessions_attended?: number;
  loyalty_tier?: string;
  feature_name?: string;
  favorite_class_type?: string;
  preferred_day_of_week?: string;
  preferred_time_of_day?: string;
  avg_booking_lead_time?: number;
}

// Union type for all params
export type AnalyticsEventParams =
  | JoinPageParams
  | PricingPlanParams
  | RegistrationFormParams
  | InviteCodeParams
  | PaymentParams
  | PaymentAbandonedParams
  | SchedulePageParams
  | ClassDetailsParams
  | BookClassParams
  | CancelBookingParams
  | MyClassesParams
  | SignInParams
  | PasswordResetParams
  | PageViewParams
  | MarketingInteractionParams
  | WaitlistParams
  | ErrorParams
  | ProfileParams
  | ExistingUserPurchaseParams
  | CRMParams
  | ZoomParams
  | EngagementParams
  | Record<string, any>;
